const profile = {
    name: 'Jaydon Frankie',
    email: 'demo@minimals.cc',
    phoneNumber: '+123-456-7891',
    role: 'Project Manager',
    password: '1234'
}

export default profile;